import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { postsAPI, siteImagesAPI, siteContentAPI } from '../lib/api';
import CTASection from '../components/shared/CTASection';
import { usePageMeta } from '../components/shared/SEO';
import { HeroSection, StatsBar } from '../components/home/HeroSection';
import { CalculatorBanner } from '../components/home/CalculatorBanner';
import { CalculatorSection } from '../components/home/CalculatorSection';
import TaxCalculatorDialog from '../components/calculator/TaxCalculatorDialog';
import { TaxSection } from '../components/home/TaxSection';
import { ServicesGrid, BenefitsSection } from '../components/home/ServicesSection';
import { AboutPreview } from '../components/home/AboutPreview';
import { BlogPreview, LeadSection } from '../components/home/BlogPreview';

const HomePage = () => {
  const [recentPosts, setRecentPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [siteImages, setSiteImages] = useState({});
  const [texts, setTexts] = useState({});
  const [calcOpen, setCalcOpen] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    if (searchParams.get('calculadora')) {
      setCalcOpen(true);
      setSearchParams({}, { replace: true });
    }
  }, [searchParams, setSearchParams]);

  useEffect(() => {
    const loadData = async () => {
      try {
        const [postsRes, imagesRes, contentRes] = await Promise.all([
          postsAPI.getRecent(3),
          siteImagesAPI.getAll().catch(() => ({ data: [] })),
          siteContentAPI.getAll().catch(() => ({ data: {} })),
        ]);
        setRecentPosts(postsRes.data);
        const imagesMap = {};
        if (imagesRes.data) {
          imagesRes.data.forEach(img => { imagesMap[img.key] = img; });
        }
        setSiteImages(imagesMap);
        setTexts(contentRes.data || {});
      } catch (error) {
        console.error('Error loading data:', error);
      } finally {
        setLoading(false);
      }
    };
    loadData();
  }, []);

  const t = (key, fallback) => texts[key] || fallback;
  const heroImg = siteImages['homepage-hero'] || {};
  const aboutImg = siteImages['homepage-about'] || {};

  usePageMeta({
    title: 'Apex Medical Hub - Contabilidade Especializada para Médicos',
    description: 'Economia tributária real para clínicas e consultórios médicos. Pague menos impostos com total segurança.',
    canonical: '/',
  });

  return (
    <div data-testid="home-page">
      <CalculatorBanner onOpen={() => setCalcOpen(true)} />
      <HeroSection t={t} heroImage={heroImg.url || ''} heroFit={heroImg.fit_mode || 'cover'} heroPosition={heroImg.position || 'center'} latestPost={recentPosts[0]} />
      <StatsBar t={t} />
      <CalculatorSection onOpen={() => setCalcOpen(true)} />
      <TaxSection />
      <ServicesGrid />
      <BenefitsSection />
      <AboutPreview t={t} aboutImage={aboutImg.url || ''} aboutFit={aboutImg.fit_mode || 'cover'} aboutPosition={aboutImg.position || 'center'} />
      <BlogPreview loading={loading} recentPosts={recentPosts} />
      <LeadSection />
      <CTASection
        title="Pronto para estruturar sua operação?"
        description="Converse com nossa equipe e descubra como a Apex pode ajudar sua clínica a crescer com mais organização e previsibilidade."
        buttonText="Agendar conversa"
        variant="default"
      />
      <TaxCalculatorDialog open={calcOpen} onOpenChange={setCalcOpen} />
    </div>
  );
};

export default HomePage;
